import React from 'react';
import {cn} from '@/utils';
import {ReactComponent as PersonIcon} from '@/assets/icons/invitation/person.svg';

interface UserInfoItemProps {
  invitedNumber: number;
  inviteNumber: number;
}

const UserInfoItem: React.FC<UserInfoItemProps> = ({
  invitedNumber,
  inviteNumber,
}) => {
  const isCompleted = invitedNumber >= inviteNumber;

  return (
    <div className="flex flex-row items-center justify-center w-[3.375rem] gap-0.5">
      <PersonIcon className={cn('size-3', !isCompleted && 'opacity-60')} />
      <span className="text-t2 text-[0.625rem]">
        {isCompleted ? (
          <span className="text-t2">{invitedNumber}</span>
        ) : (
          <span className="text-t2 opacity-60">{invitedNumber}</span>
        )}
        /{inviteNumber}
      </span>
    </div>
  );
};

export default UserInfoItem;
